export default __webpack_public_path__ + "static/media/ONT-BNB.5dec168d.svg";